import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { TrendingUp, Coins, Timer, DollarSign } from 'lucide-react';

export function StakingStats() {
  // Mock data - in real app would come from blockchain/API
  const stats = {
    totalStaked: 6500,
    totalRewards: 201.89,
    averageApy: 16.8,
    totalValue: 6142.35,
    activePools: 2,
    nextUnlock: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000), // 15 days from now
  };

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Staked</CardTitle>
          <Coins className="h-4 w-4 text-blue-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.totalStaked.toLocaleString()} NDH</div>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Across {stats.activePools} active pools
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Rewards</CardTitle>
          <TrendingUp className="h-4 w-4 text-green-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.totalRewards} NDH</div>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            ≈ ${(stats.totalRewards * 0.89).toFixed(2)}
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Average APY</CardTitle>
          <DollarSign className="h-4 w-4 text-purple-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.averageApy}%</div>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Weighted across positions
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Portfolio Value</CardTitle>
          <Timer className="h-4 w-4 text-orange-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">${stats.totalValue.toLocaleString()}</div>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Next unlock: {formatDate(stats.nextUnlock)}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}